// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"4e8e1add","168":"6f65a94b","560":"f3eebed7","579":"faacb05c","684":"8f24983c","753":"3a06dbb5","795":"7c02a026","988":"72045730"}[chunkId] + ".chunk.js";
};